module.exports = __webpack_public_path__ + "images/home-customer-video.jpg";